export default "__VITE_ASSET__CwRLlUBs__"